"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewSteps = void 0;
var ReviewSteps = {
  RATE: 'RATE',
  SHARE: 'SHARE',
  ABOUT: 'ABOUT'
};
exports.ReviewSteps = ReviewSteps;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/ReviewSteps.js
// module id = 607
// module chunks = 209 210 211 212